module.exports = __webpack_public_path__ + "static/media/logo.e1f25bd3.png";